import MarkdownView from '../../../../components/ui/MarkdownView/MarkdownView';
import { preprocessBotMarkdown } from '../../../../lib/preprocessBotMarkdown';
import classes from './ChatBubble.module.css';

export default function ChatBubble({ message, urlClickText, isStreaming = false }) {
  if (!message?.text && !isStreaming) {
    return null;
  }

  const isModel = message.sender === 'MODEL';

  if (!isModel) {
    return <div className={classes.UserContent}>{message.text}</div>;
  }

  return (
    <MarkdownView>
      {preprocessBotMarkdown(message.text, urlClickText)}
    </MarkdownView>
  );
}
